import { graphql } from "@/api/graphql/types/gql.ts";

export const GetNotificationsByAccountQuery = graphql(`
  query GetNotificationsByAccountQuery(
    $request: NotificationsMsSearchNotificationsRequest
  ) {
    NotificationsMsSearchNotifications(request: $request) {
      data {
        id
        subject
        hasAttachments
        createdTs
        status
        failedReason
        UserIdData {
          firstName
          lastName
          email
        }
      }
      pagination {
        size
        page
        total
      }
    }
  }
`);
